import { Diamond } from 'lucide-react';
import { useCheckout } from '@/components/CheckoutContext';

export default function Navbar() {
  const { open } = useCheckout();

  return (
    <nav
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-40"
      style={{ background: 'rgba(255,247,205,0.8)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)' }}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex items-center justify-between h-16">
        <a href="#" className="flex items-center gap-2" data-testid="navbar-brand" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          <Diamond className="w-5 h-5 text-[#FDC3A1]" />
          <span className="font-heading font-bold text-[#111] text-lg">DesignCarat</span>
        </a>

        <div className="hidden sm:flex items-center gap-8">
          <a href="#vault" className="font-body text-sm text-[#444] hover:text-[#111] transition-colors" onClick={(e) => { e.preventDefault(); document.querySelector('[data-testid="vault-preview-section"]')?.scrollIntoView({ behavior: 'smooth' }); }}>
            Vault
          </a>
          <a href="#pricing" className="font-body text-sm text-[#444] hover:text-[#111] transition-colors" onClick={(e) => { e.preventDefault(); document.querySelector('[data-testid="pricing-section"]')?.scrollIntoView({ behavior: 'smooth' }); }}>
            Pricing
          </a>
          <a href="#guide" className="font-body text-sm text-[#444] hover:text-[#111] transition-colors" onClick={(e) => { e.preventDefault(); document.querySelector('[data-testid="guide-section"]')?.scrollIntoView({ behavior: 'smooth' }); }}>
            Guide
          </a>
        </div>

        <button
          data-testid="navbar-cta"
          onClick={() => open('navbar_cta')}
          className="btn-accent cta-pulse text-[11px] sm:text-sm px-3 sm:px-5 py-2.5 whitespace-nowrap"
        >
          🚀 Grab Bundle Now &bull; ₹999
        </button>
      </div>
    </nav>
  );
}
